import { FC } from 'react';
import { DmIconYes } from '../icon/dmIcon';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowLeftSmall from '@/components/UI/svg/Icons/EFArrowLeftSmall';

export const ZDComp: FC = () => {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`${css.ZDComp} GtmModuleData-section`} data-section-id={css.ZDComp} data-section-title={t('sec13_title')}>
            <div className="subtitle">{t('sec13_subtitle')}</div>
            <div className="title">{t('sec13_title')}</div>
            <div className="img-box">
                {locale === 'au' ? (
                    <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_6.jpg')} alt={t('sec13_title')} aria-label={t('sec13_title')} />
                ) : (
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/12.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/12.jpg')}
                        alt={t('sec13_title')}
                        aria-label={t('sec13_title')}
                    />
                )}
            </div>
            <div className="desc-box">{t('sec13_desc')}</div>
            {locale === 'au' ? (
                <div className="item-list au-list">
                    <div className="point">
                        {t.rich('sec13_list1', {
                            big: (text: string) => <p className="big">{text}</p>,
                        })}
                    </div>
                    <div className="point">
                        {t.rich('sec13_list2', {
                            big: (text: string) => <p className="big">{text}</p>,
                        })}
                    </div>
                    <div className="point">
                        {t.rich('sec13_list3', {
                            big: (text: string) => <p className="big">{text}</p>,
                        })}
                    </div>
                </div>
            ) : (
                <div className="item-list">
                    <div className="item-box">
                        <DmIconYes />
                        <span className="icon-text">{t('sec13_list1')}</span>
                    </div>
                    <div className="item-box item-box-r">
                        <DmIconYes />
                        <span className="icon-text">{t('sec13_list2')}</span>
                    </div>
                    <div className="item-box">
                        <DmIconYes />
                        <span className="icon-text">{t('sec13_list3')}</span>
                    </div>
                    <div className="item-box item-box-r">
                        <DmIconYes />
                        <span className="icon-text">{t('sec13_list4')}</span>
                    </div>
                </div>
            )}
            {locale !== 'ph' && (
                <Link
                    className="learn-more-btn"
                    href={`https://${locale}.ecoflow.com/pages/powerstream?bundle_BS=diy`}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'select_product',
                        product_name: 'EcoFlow PowerStream',
                        list_name: t('sec13_title'),
                        button_name: t('learn_more'),
                    }}
                >
                    {t('learn_more')}
                    <div className="arrow-icon-wrapper">
                        <EFArrowLeftSmall color="#fff" className="arrow-icon normal" />
                        <EFArrowLeftSmall color="#000" className="arrow-icon hover" />
                    </div>
                </Link>
            )}
        </div>
    );
};
